module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-1200.931ac78d.svg";